/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.9.29",
    versionName: "0.2.0-nightly.2025.9.29",
    versionChannel: "nightly",
    buildDate: "2025-09-29T00:08:04.761Z",
    commitHash: "66ae70087e7d24d34457ce39df60bbe4c7cffe44",
};
